import { render, staticRenderFns } from "./ViewAsAdminSelect.vue?vue&type=template&id=c0dc5dd4&scoped=true"
import script from "./ViewAsAdminSelect.vue?vue&type=script&lang=js"
export * from "./ViewAsAdminSelect.vue?vue&type=script&lang=js"
import style0 from "./ViewAsAdminSelect.vue?vue&type=style&index=0&id=c0dc5dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dc5dd4",
  null
  
)

export default component.exports